import React from 'react';
import {Alert, Box, Card, CardContent, Pagination, Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import type {Contract} from '../../../types/contract';

interface ContractTableComponentMobileProps {
    selectedEmployeeContract: Contract | null;
    contractsPage: number;
    contractsTotalRecords: number;
    onContractsPageChange: (page: number) => Promise<void>;
    sx?: any;
}

const ContractTableComponentMobile: React.FC<ContractTableComponentMobileProps> = ({
                                                                                       selectedEmployeeContract,
                                                                                       contractsPage,
                                                                                       contractsTotalRecords,
                                                                                       onContractsPageChange,
                                                                                       sx
                                                                                   }) => {
    const {t} = useTranslation();
    const totalPages = contractsTotalRecords;

    const handlePageChange = (event: React.ChangeEvent<unknown>, page: number) => {
        onContractsPageChange(page - 1);
    };

    return (
        <Box sx={sx}>
            {selectedEmployeeContract ? (
                <Stack spacing={2}>
                    <Card variant="outlined">
                        <CardContent>
                            <Box sx={{display: 'grid', gridTemplateColumns: '1fr', gap: 1}}>
                                <Box>
                                    <Typography variant="caption" color="text.secondary">{t('employee.contract.field.contractNumber')}</Typography>
                                    <Typography>{selectedEmployeeContract.contractNumber}</Typography>
                                </Box>

                                <Box>
                                    <Typography variant="caption" color="text.secondary">{t('employee.contract.field.startDate')}</Typography>
                                    <Typography>{selectedEmployeeContract.startDate}</Typography>
                                </Box>

                                <Box>
                                    <Typography variant="caption" color="text.secondary">{t('employee.contract.field.endDate')}</Typography>
                                    <Typography>{selectedEmployeeContract.endDate}</Typography>
                                </Box>

                                <Box>
                                    <Typography variant="caption" color="text.secondary">{t('employee.contract.field.jobPosition')}</Typography>
                                    <Typography>{selectedEmployeeContract.jobPosition}</Typography>
                                </Box>

                                <Box>
                                    <Typography variant="caption" color="text.secondary">{t('employee.contract.field.payrollCalcType')}</Typography>
                                    <Typography>{selectedEmployeeContract.payrollCalcType}</Typography>
                                </Box>

                                <Box>
                                    <Typography variant="caption" color="text.secondary">{t('employee.contract.field.salaryBasis')}</Typography>
                                    <Typography>{selectedEmployeeContract.salaryBasis}</Typography>
                                </Box>

                                <Box>
                                    <Typography variant="caption" color="text.secondary">{t('employee.contract.field.baseAmount')}</Typography>
                                    <Typography>{selectedEmployeeContract.baseAmount}</Typography>
                                </Box>

                                <Box>
                                    <Typography variant="caption" color="text.secondary">
                                        {t('employee.contract.field.employerInsuranceBenefit')}</Typography>
                                    <Typography>{selectedEmployeeContract.employerInsuranceBenefit}</Typography>
                                </Box>

                                <Box>
                                    <Typography variant="caption" color="text.secondary">
                                        {t('employee.contract.field.familyInsuranceDeduction')}</Typography>
                                    <Typography>{selectedEmployeeContract.familyInsuranceDeduction}</Typography>
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>

                    {totalPages > 1 && (
                        <Box sx={{display: 'flex', justifyContent: 'center', width: '100%', mt: 1}}>
                            <Pagination
                                count={totalPages}
                                page={contractsPage + 1}
                                onChange={handlePageChange}
                                color="primary"
                                showFirstButton={totalPages > 10}
                                showLastButton={totalPages > 10}
                                siblingCount={totalPages <= 10 ? totalPages : 1}
                                boundaryCount={totalPages <= 10 ? 0 : 1}
                            />
                        </Box>
                    )}
                </Stack>
            ) : (
                <Alert severity="info">{t('employee.contract.noneYet')}</Alert>
            )}
        </Box>
    );
};

export default ContractTableComponentMobile;

